import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import creditEconomicMovementListAction from './creditEconomicMovementList.action.json' with { type: 'json' }
import { creditEconomicMovementObject } from '../creditEconomicMovementObject'

export const creditEconomicMovementExpression = expression(creditEconomicMovementObject.shape)

const creditEconomicMovementListDefinition = defineAction({
  ...creditEconomicMovementListAction,

  input: z.object({
    filter: creditEconomicMovementExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      saleInvoiceNumber: 'Número da nota',
      saleInvoiceDate: 'Data da nota',
      totalValue: 'Valor total',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(creditEconomicMovementObject),
    count: z.number(),
  }),
})

export default creditEconomicMovementListDefinition

